import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

export type BadgeColor = 'brown'
    | 'dark-green'
    | 'light-green'
    | 'dark-red'
    | 'gray'
    | 'purple'
    | 'blue';

@Component({
    selector: 'app-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BadgeComponent {

    @HostBinding('class')
    @Input() color?: BadgeColor;

    @HostBinding('class.outline')
    @Input() outline = false;

    constructor() {
    }
}
